import { render, staticRenderFns } from "./InfoModal.vue?vue&type=template&id=f55717b4&scoped=true&"
import script from "./InfoModal.vue?vue&type=script&lang=js&"
export * from "./InfoModal.vue?vue&type=script&lang=js&"
import style0 from "./InfoModal.vue?vue&type=style&index=0&id=f55717b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f55717b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3547940844/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f55717b4')) {
      api.createRecord('f55717b4', component.options)
    } else {
      api.reload('f55717b4', component.options)
    }
    module.hot.accept("./InfoModal.vue?vue&type=template&id=f55717b4&scoped=true&", function () {
      api.rerender('f55717b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/InfoModal.vue"
export default component.exports